import { Text } from '@adc/parallax-component-library';

import { Link } from './Link';
import { List, ListItem } from './List';

export function getDefaultTransComponents(
  onPressLink?: (href: string) => void,
  customNodes?: Record<string, React.ReactElement>,
  fontToken?: React.ComponentProps<typeof Text>['type']
) {
  return {
    p: <Text tag="p" display="block" marginBlockStart="$4" marginBlockEnd="$4" type={fontToken} />,
    strong: <Text tag="strong" type="$bodyBase.strong" />,
    h1: <Text tag="h1" type="$h1.strong" />,
    h2: <Text tag="h2" type="$h2.strong" />,
    h3: <Text tag="h3" type="$h3.strong" />,
    h4: <Text tag="h4" type="$h4.strong" />,
    a: <Link onPressLink={onPressLink} />,
    li: <ListItem fontToken={fontToken} />,
    ul: <List listType="ul" />,
    ol: <List listType="ol" />,
    br: <br />,
    ...customNodes,
  };
}
